import classNames from 'classnames';
import React from 'react';

import { PageLayoutHeader, type PageLayoutHeaderProps } from './PageLayoutHeader';

import './KanbanPageLayout.scss';

interface KanbanPageLayoutProps extends PageLayoutHeaderProps {
	/** The content that appears above the kanban board  */
	aboveKanbanContent?: React.ReactNode
	/** The main kanban content */
	kanbanContent: React.ReactNode;
	/** Optional class name for custom styling */
	className?: string;
}

/**
 * Layout component for pages with kanban boards.
 * Provides consistent structure for above-table controls and kanban content.
 */
export const KanbanPageLayout: React.FC<KanbanPageLayoutProps> = ({
	title,
	breadcrumb,
	aboveKanbanContent,
	size = 'heading',
	kanbanContent: tableContent,
	className,
}) => {
	const pageLayoutHeader =
		title || breadcrumb ? (
			<PageLayoutHeader title={title} breadcrumb={breadcrumb} size={size} />
		) : null;

	return (
		<div className={classNames('kanban-page-layout', className)}>
			{(pageLayoutHeader || aboveKanbanContent) && (
				<div className='kanban-page-layout__above'>
					{pageLayoutHeader}
					{aboveKanbanContent}
				</div>
			)}
			<div className='kanban-page-layout__main'>{tableContent}</div>
		</div>
	);
};
